export const COOKIE_SETTINGS = {
  path: (import.meta.env.BASE_URL || "/").replace(/\/+$/, "") || "/", // Important for SPA
  maxAge: 365 * 86400, // 1 Day = 24 Hrs = 24*60*60 = 86400.
};
